export default __webpack_public_path__ + "static/media/27t.5d692ca3.jpg";